import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import axios from 'axios';
import Breadcrumbs from '../components/Breadcrumbs';

function CourseDetail() {
  const API_URL = process.env.REACT_APP_API_URL;
  const { interfaceLang, courseLang, courseSlug } = useParams();  // Récupère l'ID du cours à partir de l'URL
  const [course, setCourse] = useState(null);  // Stocker les détails du cours
  const [exercises, setExercises] = useState([]);  // Stocker les exercices associés

  useEffect(() => {
    const token = localStorage.getItem('access_token');

    // Récupérer les détails du cours
    axios.get(`${API_URL}/cours/api/courses-detail/${courseSlug}/`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    })
    .then(response => {
      console.log(response.data)
      setCourse(response.data);  // Assigner les détails du cours
    })
    .catch(error => {
      console.error("Erreur lors de la récupération du cours :", error);
    });

    // Récupérer les exercices associés au cours
    console.log(courseSlug)
    axios.get(`${API_URL}/cours/api/exercises/course/${courseSlug}/`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    })
    .then(response => {
      const sortedExercises = response.data.sort((a, b) => a.id - b.id); // Trier ici
      setExercises(sortedExercises);  // Assigner les exercices
    })
    .catch(error => {
      console.error("Erreur lors de la récupération des exercices :", error);
    });
  }, [courseSlug]);

  // Exemple de structure pour le fil d'Ariane
  const breadcrumbsLinks = [
    { label: 'Accueil', path: `/${interfaceLang}` },
    { label: 'Cours d\'espagnol', path:  `/${interfaceLang}/courses/${courseLang}` },
    { label: course ? course.title : 'Chargement...', path: `/${interfaceLang}/courses/${courseLang}/${courseSlug}` }
  ];

  return (
    <div className="course-detail max-w-4xl mx-auto mt-8">

      {/* Utilisation du fil d'Ariane */}
      <Breadcrumbs links={breadcrumbsLinks} />
      
      {course ? (
        <div>
          <h1 className="text-3xl font-bold text-blue-600 mb-4">{course.title}</h1>
          <p className="text-lg text-gray-700 mb-6">{course.description}</p>
          
          {/* Contenu du cours en HTML */}
          <div 
            className="course-content mb-8" 
            dangerouslySetInnerHTML={{ __html: course.content }}
          ></div>
          
          <h2 className="text-2xl font-semibold text-blue-500 mb-4">Exercices associés</h2>
          <ul className="grid grid-cols-1 sm:grid-cols-2 gap-6">
            {exercises.map(exercise => (
              <li key={exercise.id} className="bg-white p-6 rounded-lg shadow-lg hover:shadow-xl transition">
                <Link to={`/${interfaceLang}/course/${courseLang}/${course.slug}/exercise/${exercise.id}`}>
                  {/* Titre de l'exercice */}
                  <h3 className="text-xl font-semibold text-gray-800 mb-2">
                    Exercice {exercise.order} : {exercise.question_type}
                  </h3>
                  {/* Informations supplémentaires */}
                  <div className="text-gray-600">
                    <p className="text-sm mb-2">XP : {exercise.xp_provided}</p>
                    <p className="text-sm">Complété : {exercise.already_completed ? 'Oui' : 'Non'}</p>
                  </div>
                </Link>
              </li>
            ))}
          </ul>
        </div>
      ) : (
        <p>Chargement du cours...</p>
      )}
    </div>
  );
}

export default CourseDetail;
